import AuthHeader from "./auth.header";
import axios from "axios";
const baseUrlImage = AuthHeader?.baseUrl;

const login = async (data: { mobile: string, password: string }): Promise<any> => {
  const formData = {
    user_email: data.mobile,
    password: data.password
  }

  const response = await AuthHeader.axiosInstanceSelf().post("login", formData);
  if (response.data.status === 200) {
    localStorage.setItem("w_token",
      JSON.stringify({
        access_token: response.data.data.token,
        name: response.data.data.name,
      })
    );
  }
  return response.data;
};

const profile = async (): Promise<any> => {
  const response = await AuthHeader.axiosInstanceSelf().get("profile");
  return response.data;
}

const wallet = async (): Promise<any> => {
  const response = await AuthHeader.axiosInstanceSelf().get("wallet");
  return response.data;
}

const logout = async (): Promise<any> => {
  const response = await AuthHeader.axiosInstanceSelf().get("logout");
  if (response.data.status === 200) {
    localStorage.removeItem("w_token");
  }
  return response.data;
}


const getGames = async (type: any, sub_type: any, sports_id: any): Promise<any> => {

  // const formData = {
  //     type: type,
  //     sub_type:sub_type,
  //     sport_id:sports_id
  //   }  
  //   let localData = localStorage.getItem("w_token");
  //   const token = localData ? JSON.parse(localStorage.getItem("w_token") || "") : '';

  //   let url = token?.access_token ? 'details' : 'loadgame';
  //   const response = await AuthHeader.axiosInstanceSelf().post(url, formData);

  const response = await AuthHeader.axiosInstance().get('matches');
  return response.data;
}

const getMatchTitle = async (match_id: any): Promise<any> => {
  const response = await AuthHeader.axiosInstance().get('match/' + match_id);
  return response.data;
}

const matchDetails = async (match_id: any): Promise<any> => {
  //   return{
  //     "success": true,
  //     "status": 200,
  //     "message": "Success",
  //     "data": {
  //         "t1": [
  //             [
  //                 {
  //                     "mid": "1.239096254",
  //                     "mstatus": "OPEN",
  //                     "mname": "MATCH_ODDS",
  //                     "iplay": "True",
  //                     "sid": 55000,
  //                     "nat": "India",
  //                     "b1": 1.149999999999999911182158029987476766109466552734375,
  //                     "bs1": 249582.64999999999417923390865325927734375,
  //                     "b2": 1.1399999999999999023003738329862244427204132080078125,
  //                     "bs2": 83448.330000000001746229827404022216796875,
  //                     "b3": 1.12999999999999989341858963598497211933135986328125,
  //                     "bs3": 96216.0700000000069849193096160888671875,
  //                     "l1": 1.1599999999999999200639422269887290894985198974609375,
  //                     "ls1": 106507.240000000005238689482212066650390625,
  //                     "l2": 1.1699999999999999289457264239899814128875732421875,
  //                     "ls2": 34065.1900000000023283064365386962890625,
  //                     "l3": 1.1799999999999999378275106209912337362766265869140625,
  //                     "ls3": 16146.639999999999417923390865325927734375,
  //                     "status": "ACTIVE",
  //                     "srno": 1,
  //                     "gtype": "Match",
  //                     "utime": "0"
  //                 },
  //                 {
  //                     "mid": "1.239096254",
  //                     "mstatus": "OPEN",
  //                     "mname": "MATCH_ODDS",
  //                     "iplay": "True",
  //                     "sid": 91991,
  //                     "nat": "England",
  //                     "b1": 7.4000000000000003552713678800500929355621337890625,
  //                     "bs1": 203.659999999999996589394868351519107818603515625,
  //                     "b2": 7.20000000000000017763568394002504646778106689453125,
  //                     "bs2": 17891.86999999999898136593401432037353515625,
  //                     "b3": 7,
  //                     "bs3": 1234.910000000000081854523159563541412353515625,
  //                     "l1": 7.5999999999999996447286321199499070644378662109375,
  //                     "ls1": 932.4199999999999590727384202182292938232421875,
  //                     "l2": 7.79999999999999982236431605997495353221893310546875,
  //                     "ls2": 37358.77999999999883584678173065185546875,
  //                     "l3": 8,
  //                     "ls3": 61.60000000000000142108547152020037174224853515625,
  //                     "status": "ACTIVE",
  //                     "srno": 2,
  //                     "gtype": "Match",
  //                     "utime": "0"
  //                 }
  //             ]
  //         ],
  //         "t2": [
  //             {
  //                 "bm1": [
  //                     {
  //                         "mid": "1.239096254",
  //                         "mname": "Bookmaker",
  //                         "remark": "ENGLAND EFL CUP , SPAIN COPA Football Matches Advance Bet Started In Our Exchange",
  //                         "min": 100,
  //                         "max": 10000000,
  //                         "sid": 1,
  //                         "nat": "India",
  //                         "b1": 14.5,
  //                         "bs1": 2500000,
  //                         "l1": 16,
  //                         "ls1": 2500000,
  //                         "s": "ACTIVE",
  //                         "sr": 1,
  //                         "gtype": "Match1",
  //                         "utime": "0"
  //                     },
  //                     {
  //                         "mid": "1.239096254",
  //                         "mname": "Bookmaker",
  //                         "remark": "ENGLAND EFL CUP , SPAIN COPA Football Matches Advance Bet Started In Our Exchange",
  //                         "min": 100,
  //                         "max": 10000000,
  //                         "sid": 2,
  //                         "nat": "England",
  //                         "b1": 625,
  //                         "bs1": 625000,
  //                         "l1": 689,
  //                         "ls1": 625000,
  //                         "s": "ACTIVE",
  //                         "sr": 2,
  //                         "gtype": "Match1",
  //                         "utime": "0"
  //                     }
  //                 ]
  //             }
  //         ],
  //         "t8": [
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 1,
  //                 "nat": "YES",
  //                 "b1": 0,
  //                 "bs1": 0,
  //                 "l1": 0,
  //                 "ls1": 0,
  //                 "gtype": "Tied Match",
  //                 "gstatus": "SUSPENDED",
  //                 "remark": "",
  //                 "min": 0,
  //                 "max": 0,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 2,
  //                 "nat": "NO",
  //                 "b1": 0.5,
  //                 "bs1": 100000,
  //                 "l1": 1,
  //                 "ls1": 100000,
  //                 "gtype": "Tied Match",
  //                 "gstatus": "ACTIVE",
  //                 "remark": "",
  //                 "min": 0,
  //                 "max": 0,
  //                 "utime": "0"
  //             }
  //         ],
  //         "t3": [
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 616,
  //                 "nat": "10 over run IND",
  //                 "b1": 58,
  //                 "bs1": 90,
  //                 "l1": 58,
  //                 "ls1": 110,
  //                 "gtype": "Fancy",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 400000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 617,
  //                 "nat": "10 over run bhav IND",
  //                 "b1": 58,
  //                 "bs1": 90,
  //                 "l1": 58,
  //                 "ls1": 105,
  //                 "gtype": "Fancy",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 50000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 624,
  //                 "nat": "2 over run IND",
  //                 "b1": 8,
  //                 "bs1": 100,
  //                 "l1": 7,
  //                 "ls1": 100,
  //                 "gtype": "Fancy",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 300000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 625,
  //                 "nat": "2.3 over run IND",
  //                 "b1": 12,
  //                 "bs1": 100,
  //                 "l1": 11,
  //                 "ls1": 100,
  //                 "gtype": "Fancy",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 300000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 628,
  //                 "nat": "4 over run IND",
  //                 "b1": 21,
  //                 "bs1": 100,
  //                 "l1": 20,
  //                 "ls1": 100,
  //                 "gtype": "Fancy",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 300000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 156,
  //                 "nat": "Total Match Runs(IND vs ENG)",
  //                 "b1": 499,
  //                 "bs1": 100,
  //                 "l1": 497,
  //                 "ls1": 100,
  //                 "gtype": "Fancy",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 100000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 19,
  //                 "nat": "Fall of 1st wkt IND(IND vs ENG)adv",
  //                 "b1": 38,
  //                 "bs1": 90,
  //                 "l1": 38,
  //                 "ls1": 110,
  //                 "gtype": "Fancy",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 200000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 844,
  //                 "nat": "1st 2 wkt runs IND",
  //                 "b1": 83,
  //                 "bs1": 90,
  //                 "l1": 83,
  //                 "ls1": 110,
  //                 "gtype": "Fancy",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 50000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 845,
  //                 "nat": "1st 3 wkt runs IND",
  //                 "b1": 130,
  //                 "bs1": 90,
  //                 "l1": 130,
  //                 "ls1": 110,
  //                 "gtype": "Fancy",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 50000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 846,
  //                 "nat": "1st 4 wkt runs IND",
  //                 "b1": 177,
  //                 "bs1": 80,
  //                 "l1": 177,
  //                 "ls1": 100,
  //                 "gtype": "Fancy",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 50000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 913,
  //                 "nat": "Fall of 1st wkt run bhav IND",
  //                 "b1": 6,
  //                 "bs1": 3,
  //                 "l1": 6,
  //                 "ls1": 6,
  //                 "gtype": "Fancy",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 300000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 27,
  //                 "nat": "Rohit Sharma run(IND vs ENG)adv",
  //                 "b1": 33,
  //                 "bs1": 100,
  //                 "l1": 33,
  //                 "ls1": 120,
  //                 "gtype": "Fancy",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 200000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 860,
  //                 "nat": "Rohit Sharma run bhav",
  //                 "b1": 25,
  //                 "bs1": 60,
  //                 "l1": 25,
  //                 "ls1": 80,
  //                 "gtype": "Fancy",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 200000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 861,
  //                 "nat": "Rohit Sharma run bhav 2",
  //                 "b1": 1,
  //                 "bs1": 6,
  //                 "l1": 1,
  //                 "ls1": 9,
  //                 "gtype": "Fancy",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 300000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 864,
  //                 "nat": "Y Jaiswal run",
  //                 "b1": 37,
  //                 "bs1": 90,
  //                 "l1": 37,
  //                 "ls1": 110,
  //                 "gtype": "Fancy",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 200000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 865,
  //                 "nat": "Y Jaiswal run bhav",
  //                 "b1": 25,
  //                 "bs1": 45,
  //                 "l1": 25,
  //                 "ls1": 60,
  //                 "gtype": "Fancy",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 200000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 866,
  //                 "nat": "Y Jaiswal run bhav 2",
  //                 "b1": 6,
  //                 "bs1": 4,
  //                 "l1": 6,
  //                 "ls1": 7,
  //                 "gtype": "Fancy",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 300000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 31,
  //                 "nat": "1st wkt pship Boundaries IND(IND vs ENG)adv",
  //                 "b1": 6,
  //                 "bs1": 100,
  //                 "l1": 5,
  //                 "ls1": 100,
  //                 "gtype": "Fancy",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 10000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 33,
  //                 "nat": "Rohit Sharma Boundaries(IND vs ENG)adv",
  //                 "b1": 5,
  //                 "bs1": 100,
  //                 "l1": 4,
  //                 "ls1": 100,
  //                 "gtype": "Fancy",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 10000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 867,
  //                 "nat": "Y Jaiswal boundaries",
  //                 "b1": 6,
  //                 "bs1": 100,
  //                 "l1": 5,
  //                 "ls1": 100,
  //                 "gtype": "Fancy",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 10000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 37,
  //                 "nat": "1st wkt lost to IND balls(IND vs ENG)adv",
  //                 "b1": 38,
  //                 "bs1": 90,
  //                 "l1": 38,
  //                 "ls1": 110,
  //                 "gtype": "Fancy",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 10000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 39,
  //                 "nat": "How many balls face by Rohit Sharma(IND vs ENG)adv",
  //                 "b1": 32,
  //                 "bs1": 100,
  //                 "l1": 32,
  //                 "ls1": 120,
  //                 "gtype": "Fancy",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 10000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 880,
  //                 "nat": "How many balls face by Y Jaiswal",
  //                 "b1": 35,
  //                 "bs1": 90,
  //                 "l1": 35,
  //                 "ls1": 110,
  //                 "gtype": "Fancy",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 10000,
  //                 "utime": "0"
  //             }
  //         ],
  //         "t7": [
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 885,
  //                 "nat": "Only 3 over run IND",
  //                 "b1": 7,
  //                 "bs1": 100,
  //                 "l1": 6,
  //                 "ls1": 100,
  //                 "gtype": "Fancy",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 50000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 896,
  //                 "nat": "1.4 to 1.6 ball No Boundaries IND",
  //                 "b1": 4,
  //                 "bs1": 60,
  //                 "l1": 4,
  //                 "ls1": 80,
  //                 "gtype": "Fancy",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 300000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 897,
  //                 "nat": "2.1 to 2.3 ball No Boundaries IND",
  //                 "b1": 0,
  //                 "bs1": 0,
  //                 "l1": 0,
  //                 "ls1": 0,
  //                 "gtype": "Fancy",
  //                 "gstatus": "SUSPENDED",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 300000,
  //                 "utime": "0"
  //             }
  //         ],
  //         "t4": [
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 2503,
  //                 "nat": "Lunch Favourite Match Odds(IND vs ENG)adv",
  //                 "b1": 0,
  //                 "bs1": 0,
  //                 "l1": 0,
  //                 "ls1": 0,
  //                 "gtype": "fancy1",
  //                 "gstatus": "SUSPENDED",
  //                 "remark": "Lunch Favourite Is IND",
  //                 "min": 100,
  //                 "max": 100000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 2604,
  //                 "nat": "1st wkt Caught out IND",
  //                 "b1": 1.399999999999999911182158029987476766109466552734375,
  //                 "bs1": 100000,
  //                 "l1": 1.600000000000000088817841970012523233890533447265625,
  //                 "ls1": 100000,
  //                 "gtype": "fancy1",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 100000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 2619,
  //                 "nat": "1st wkt Nextman out Rohit Sharma",
  //                 "b1": 1.6999999999999999555910790149937383830547332763671875,
  //                 "bs1": 100000,
  //                 "l1": 1.9499999999999999555910790149937383830547332763671875,
  //                 "ls1": 100000,
  //                 "gtype": "fancy1",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 100000,
  //                 "utime": "0"
  //             }
  //         ],
  //         "t5": [
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 2533,
  //                 "nat": "Fall of 1st wkt meter IND adv",
  //                 "b1": 56,
  //                 "bs1": 100,
  //                 "l1": 53,
  //                 "ls1": 100,
  //                 "gtype": "meter",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 10,
  //                 "max": 3000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 2535,
  //                 "nat": "Rohit Sharma meter adv",
  //                 "b1": 44,
  //                 "bs1": 100,
  //                 "l1": 41,
  //                 "ls1": 100,
  //                 "gtype": "meter",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 10,
  //                 "max": 10000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 2615,
  //                 "nat": "Y Jaiswal meter",
  //                 "b1": 51,
  //                 "bs1": 100,
  //                 "l1": 48,
  //                 "ls1": 100,
  //                 "gtype": "meter",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 10,
  //                 "max": 10000,
  //                 "utime": "0"
  //             }
  //         ],
  //         "t6": [
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 2519,
  //                 "nat": "2nd inn 5 over run odd even(IND vs ENG)adv",
  //                 "b1": 1.9499999999999999555910790149937383830547332763671875,
  //                 "bs1": 2500000,
  //                 "l1": 1.9499999999999999555910790149937383830547332763671875,
  //                 "ls1": 2500000,
  //                 "gtype": "oddeven",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 200000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 2520,
  //                 "nat": "2nd inn 10 over run odd even(IND vs ENG)adv",
  //                 "b1": 1.9499999999999999555910790149937383830547332763671875,
  //                 "bs1": 2500000,
  //                 "l1": 1.9499999999999999555910790149937383830547332763671875,
  //                 "ls1": 2500000,
  //                 "gtype": "oddeven",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 200000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 2521,
  //                 "nat": "2nd inn 15 over run odd even(IND vs ENG)adv",
  //                 "b1": 1.9499999999999999555910790149937383830547332763671875,
  //                 "bs1": 2500000,
  //                 "l1": 1.9499999999999999555910790149937383830547332763671875,
  //                 "ls1": 2500000,
  //                 "gtype": "oddeven",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 200000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 2522,
  //                 "nat": "2nd inn 20 over run odd even(IND vs ENG)adv",
  //                 "b1": 1.9499999999999999555910790149937383830547332763671875,
  //                 "bs1": 2500000,
  //                 "l1": 1.9499999999999999555910790149937383830547332763671875,
  //                 "ls1": 2500000,
  //                 "gtype": "oddeven",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 200000,
  //                 "utime": "0"
  //             },
  //             {
  //                 "mid": "1.239096254",
  //                 "sid": 2523,
  //                 "nat": "2nd inn 25 over run odd even(IND vs ENG)adv",
  //                 "b1": 1.9499999999999999555910790149937383830547332763671875,
  //                 "bs1": 2500000,
  //                 "l1": 1.9499999999999999555910790149937383830547332763671875,
  //                 "ls1": 2500000,
  //                 "gtype": "oddeven",
  //                 "gstatus": "",
  //                 "remark": "",
  //                 "min": 100,
  //                 "max": 200000,
  //                 "utime": "0"
  //             }
  //         ],
  //         "live_score": {
  //             "match_id": 6738,
  //             "series_id": 482,
  //             "tv_id": 33999372,
  //             "is_hundred": 1,
  //             "match_over": "50",
  //             "min_rate": 1.149999999999999911182158029987476766109466552734375,
  //             "max_rate": 1.1599999999999999200639422269887290894985198974609375,
  //             "fav_team": "IND",
  //             "toss": "England have won the toss and have opted to bat",
  //             "result": "",
  //             "match_type": "ODI",
  //             "powerplay": "1",
  //             "s_ovr": "10",
  //             "s_min": "58",
  //             "s_max": "59",
  //             "team_a_id": 1,
  //             "team_a": "India",
  //             "team_a_short": "IND",
  //             "team_a_img": "https:\/\/cricketchampion.co.in\/webroot\/img\/teams\/834841018_team.png",
  //             "team_b_id": 12,
  //             "team_b": "England",
  //             "team_b_short": "ENG",
  //             "team_b_img": "https:\/\/cricketchampion.co.in\/webroot\/img\/teams\/1431327986_team.png",
  //             "next_batsman": "-",
  //             "current_inning": "2",
  //             "batsman": [
  //                 {
  //                     "player_id": 3133,
  //                     "name": "Yashasvi Jaiswal*",
  //                     "img": "https:\/\/cricketchampion.co.in\/webroot\/img\/players\/2066006286_player.png",
  //                     "strike_status": 1,
  //                     "run": 5,
  //                     "ball": 6,
  //                     "fours": 1,
  //                     "sixes": 0,
  //                     "strike_rate": "83.33"
  //                 },
  //                 {
  //                     "player_id": 2341,
  //                     "name": "Rohit Sharma",
  //                     "img": "https:\/\/cricketchampion.co.in\/webroot\/img\/players\/872259917_player.png",
  //                     "strike_status": 0,
  //                     "run": 0,
  //                     "ball": 3,
  //                     "fours": 0,
  //                     "sixes": 0,
  //                     "strike_rate": "0.00"
  //                 }
  //             ],
  //             "bolwer": {
  //                 "player_id": 2309,
  //                 "name": "Saqib Mahmood",
  //                 "img": "https:\/\/cricketchampion.co.in\/webroot\/img\/players\/859752097_player.png",
  //                 "run": 4,
  //                 "maiden": 0,
  //                 "over": "0.3",
  //                 "wicket": 0,
  //                 "economy": "8.00"
  //             },
  //             "first_circle": "0",
  //             "second_circle": "",
  //             "balling_team": "12",
  //             "batting_team": "1",
  //             "team_b_score": {
  //                 "1": {
  //                     "score": 248,
  //                     "wicket": 10,
  //                     "ball": 286,
  //                     "over": "47.4"
  //                 },
  //                 "team_id": 12
  //             },
  //             "team_b_scores": "248-10",
  //             "team_b_over": "47.4",
  //             "team_b_scores_over": [
  //                 {
  //                     "score": "248-10",
  //                     "over": "47.4"
  //                 }
  //             ],
  //             "ball_rem": 291,
  //             "need_run_ball": "India NEED 244 RUNS IN 48.3 OVERS TO WIN",
  //             "trail_lead": "",
  //             "s_history_1": [
  //                 {
  //                     "team_id": 12,
  //                     "over": "10",
  //                     "s_o_min": "55",
  //                     "s_min": "51",
  //                     "s_o_max": "57",
  //                     "s_max": "88",
  //                     "max_rate": 1.3200000000000000621724893790087662637233734130859375,
  //                     "min_rate": 1.2800000000000000266453525910037569701671600341796875,
  //                     "fav_team": "IND",
  //                     "wicket": 3,
  //                     "score": 77
  //                 },
  //                 {
  //                     "team_id": 12,
  //                     "over": "20",
  //                     "s_o_min": "120",
  //                     "s_min": "114",
  //                     "s_o_max": "122",
  //                     "s_max": "163",
  //                     "max_rate": 1.25,
  //                     "min_rate": 1.2399999999999999911182158029987476766109466552734375,
  //                     "fav_team": "IND",
  //                     "wicket": 4,
  //                     "score": 114
  //                 },
  //                 {
  //                     "team_id": 12,
  //                     "over": "30",
  //                     "s_o_min": "161",
  //                     "s_min": "160",
  //                     "s_o_max": "163",
  //                     "s_max": "170",
  //                     "max_rate": 1.399999999999999911182158029987476766109466552734375,
  //                     "min_rate": 1.3899999999999999023003738329862244427204132080078125,
  //                     "fav_team": "IND",
  //                     "wicket": 4,
  //                     "score": 162
  //                 },
  //                 {
  //                     "team_id": 12,
  //                     "over": "35",
  //                     "s_o_min": "189",
  //                     "s_min": "179",
  //                     "s_o_max": "191",
  //                     "s_max": "191",
  //                     "max_rate": 1.3200000000000000621724893790087662637233734130859375,
  //                     "min_rate": 1.310000000000000053290705182007513940334320068359375,
  //                     "fav_team": "IND",
  //                     "wicket": 5,
  //                     "score": 182
  //                 },
  //                 {
  //                     "team_id": 12,
  //                     "over": "40",
  //                     "s_o_min": "209",
  //                     "s_min": "202",
  //                     "s_o_max": "211",
  //                     "s_max": "211",
  //                     "max_rate": 1.189999999999999946709294817992486059665679931640625,
  //                     "min_rate": 1.1799999999999999378275106209912337362766265869140625,
  //                     "fav_team": "IND",
  //                     "wicket": 7,
  //                     "score": 206
  //                 },
  //                 {
  //                     "team_id": 12,
  //                     "over": "50",
  //                     "s_o_min": "253",
  //                     "s_min": "245",
  //                     "s_o_max": "255",
  //                     "s_max": "265",
  //                     "max_rate": 1.1599999999999999200639422269887290894985198974609375,
  //                     "min_rate": 1.149999999999999911182158029987476766109466552734375,
  //                     "fav_team": "IND",
  //                     "wicket": 10,
  //                     "score": 248
  //                 }
  //             ],
  //             "s_run": 54,
  //             "s_ball": 51,
  //             "partnership": {
  //                 "ball": 9,
  //                 "run": 5
  //             },
  //             "yet_to_bet": [
  //                 "Shreyas Iyer",
  //                 "Shubman Gill",
  //                 "KL Rahul",
  //                 "Hardik Pandya",
  //                 "Axar Patel",
  //                 "Ravindra Jadeja",
  //                 "Harshit Rana",
  //                 "Kuldeep Yadav"
  //             ],
  //             "c_team_score": 5,
  //             "curr_rate": "3.33",
  //             "projected_score": [
  //                 {
  //                     "over": 5,
  //                     "cur_rate": "3.33",
  //                     "cur_rate_score": 16,
  //                     "cur_rate_1": "3.00",
  //                     "cur_rate_1_score": 15,
  //                     "cur_rate_2": "4.00",
  //                     "cur_rate_2_score": 20,
  //                     "cur_rate_3": "5.00",
  //                     "cur_rate_3_score": 25
  //                 },
  //                 {
  //                     "over": 10,
  //                     "cur_rate": "3.33",
  //                     "cur_rate_score": 33,
  //                     "cur_rate_1": "3.00",
  //                     "cur_rate_1_score": 30,
  //                     "cur_rate_2": "4.00",
  //                     "cur_rate_2_score": 40,
  //                     "cur_rate_3": "5.00",
  //                     "cur_rate_3_score": 50
  //                 },
  //                 {
  //                     "over": 20,
  //                     "cur_rate": "3.33",
  //                     "cur_rate_score": 66,
  //                     "cur_rate_1": "3.00",
  //                     "cur_rate_1_score": 60,
  //                     "cur_rate_2": "4.00",
  //                     "cur_rate_2_score": 80,
  //                     "cur_rate_3": "5.00",
  //                     "cur_rate_3_score": 100
  //                 },
  //                 {
  //                     "over": 30,
  //                     "cur_rate": "3.33",
  //                     "cur_rate_score": 99,
  //                     "cur_rate_1": "3.00",
  //                     "cur_rate_1_score": 90,
  //                     "cur_rate_2": "4.00",
  //                     "cur_rate_2_score": 120,
  //                     "cur_rate_3": "5.00",
  //                     "cur_rate_3_score": 150
  //                 },
  //                 {
  //                     "over": 40,
  //                     "cur_rate": "3.33",
  //                     "cur_rate_score": 133,
  //                     "cur_rate_1": "3.00",
  //                     "cur_rate_1_score": 120,
  //                     "cur_rate_2": "4.00",
  //                     "cur_rate_2_score": 160,
  //                     "cur_rate_3": "5.00",
  //                     "cur_rate_3_score": 200
  //                 },
  //                 {
  //                     "over": 50,
  //                     "cur_rate": "3.33",
  //                     "cur_rate_score": 166,
  //                     "cur_rate_1": "3.00",
  //                     "cur_rate_1_score": 150,
  //                     "cur_rate_2": "4.00",
  //                     "cur_rate_2_score": 200,
  //                     "cur_rate_3": "5.00",
  //                     "cur_rate_3_score": 250
  //                 }
  //             ],
  //             "last_bolwer": {
  //                 "player_id": 5453,
  //                 "name": "Jofra Archer",
  //                 "img": "https:\/\/cricketchampion.co.in\/webroot\/img\/players\/2046759917_player.png",
  //                 "over": "1",
  //                 "run": 1,
  //                 "maiden": 0,
  //                 "wicket": 0,
  //                 "economy": "1.00"
  //             },
  //             "lastwicket": {
  //                 "player": "",
  //                 "run": "",
  //                 "ball": ""
  //             },
  //             "udrs": {
  //                 "team_a": {
  //                     "left": 2,
  //                     "pass": 0,
  //                     "fail": 0
  //                 },
  //                 "team_b": {
  //                     "left": 2,
  //                     "pass": 0,
  //                     "fail": 0
  //                 }
  //             },
  //             "team_a_score": {
  //                 "2": {
  //                     "score": 5,
  //                     "wicket": 0,
  //                     "ball": 9,
  //                     "over": "1.3"
  //                 },
  //                 "team_id": 1
  //             },
  //             "team_a_scores": "5-0",
  //             "team_a_over": "1.3",
  //             "team_a_scores_over": [
  //                 {
  //                     "score": "5-0",
  //                     "over": "1.3"
  //                 }
  //             ],
  //             "target": 249,
  //             "rr_rate": "5.03",
  //             "run_need": 244,
  //             "s_history_2": [
  //                 {
  //                     "team_id": 1,
  //                     "over": "10",
  //                     "s_o_min": "60",
  //                     "s_min": "56",
  //                     "s_o_max": "62",
  //                     "s_max": "62",
  //                     "max_rate": "",
  //                     "min_rate": "",
  //                     "fav_team": "",
  //                     "wicket": "",
  //                     "score": ""
  //                 }
  //             ],
  //             "last4overs": [
  //                 {
  //                     "over": 1,
  //                     "balls": [
  //                         "0",
  //                         "0",
  //                         "1",
  //                         "0",
  //                         "0",
  //                         "0"
  //                     ],
  //                     "runs": 1
  //                 },
  //                 {
  //                     "over": 2,
  //                     "balls": [
  //                         "4",
  //                         "0",
  //                         "0"
  //                     ],
  //                     "runs": 4
  //                 }
  //             ],
  //             "last36ball": [
  //                 "4",
  //                 "0",
  //                 "0"
  //             ]
  //         },
  //         "live_tv": "https:\/\/crickfast.com\/cric-api\/tv.php?match_id=33999372"
  //     }
  // }
  const response = await AuthHeader.axiosInstance().get("match-details/" + match_id);
  return response.data;
}

const loadGames = async (type: any, sub_type: any, uuid: any): Promise<any> => {
  const formData = {
    type: type,
    sub_type: sub_type,
    game_uuid: uuid
  }
  const response = await AuthHeader.axiosInstanceSelf().post("details", formData);
  return response.data;
}

const getGameCasino = async (type: any, sub_type: any): Promise<any> => {
  const formData = {
    type: type,
    sub_type: sub_type
  }
  let localData = localStorage.getItem("w_token");
  const token = localData ? JSON.parse(localStorage.getItem("w_token") || "") : '';

  let url = token?.access_token ? 'details' : 'loadgame';
  const response = await AuthHeader.axiosInstanceSelf().post(url, formData);
  return response.data;
}

const placeBetCricket = async (formData: any): Promise<any> => {
  // return formData;

  const response = await AuthHeader.axiosInstanceSelf().post('place-bet', formData);
  return response.data;
}

const currency = async (): Promise<any> => {
  const response = await AuthHeader.axiosInstanceSelf().get('currencies');
  return response.data;
}

const statements = async (formData: any): Promise<any> => {
  let currentPage = formData?.page ? formData?.page : 1
  const response = await AuthHeader.axiosInstanceSelf().post('statements?page=' + currentPage, formData);
  return response.data;
}

const statementsDownload = async (formData: any): Promise<any> => {

  // return {
  //   "success": true,
  //   "status": 200,
  //   "message": "Success",
  //   "data": {
  //     "id": 74,
  //     "parentId": null,
  //     "value": "",
  //     "children": [
  //       {
  //         "id": 62,
  //         "parentId": 74,
  //         "value": "Task 7",
  //         "txn": "3131",
  //         "closing": "320",

  //       },
  //       {
  //         "id": 63,
  //         "parentId": 75,
  //         "value": "Task 8",
  //         "txn": "31",
  //         "closing": "321",

  //       }

  //     ]
  //   }
  // }
  const response = await AuthHeader.axiosInstanceSelf().post('download-statements', formData);
  return response.data;
}

const statementsDetails = async (formData: any): Promise<any> => {
  // return formData;  
  const response = await AuthHeader.axiosInstanceSelf().post('statement-detail', formData);
  return response.data;
}

const getActiveMinesGame = async (): Promise<any> => {
  //   return {
  //     "success": true,
  //     "status": 200,
  //     "message": "Success",
  //     "data": {
  //         "minesNext": {
  //             "id": 27,
  //             "active": 0,
  //             "payoutMultiplier": "0.00",
  //             "amountMultiplier": "0.00",
  //             "amount": "1.00",
  //             "payout": "0.00"
  //         },
  //         "state": {
  //             "mines": [
  //                 25, 3
  //             ],
  //             "minesCount": 1,
  //             "grid": 5,
  //             "type": "manual",
  //             "rounds": [
  //                 2,
  //                 5,
  //                 25
  //             ]
  //         }
  //     }
  // };  
  const response = await AuthHeader.axiosInstanceSelf().get('generate-mines');
  return response.data;
}

const minesGame = async (formData: any): Promise<any> => {
  // return formData;  
  const response = await AuthHeader.axiosInstanceSelf().post('generate-mines', formData);
  return response.data;
}

const checkCellData = async (formData: any): Promise<any> => {
  // return formData;  
  const response = await AuthHeader.axiosInstanceSelf().post('open-field', formData);
  return response.data;
}

const chashOutMines = async (): Promise<any> => {
  //   return {
  //     "success": true,
  //     "status": 200,
  //     "message": "Success",
  //     "data": {
  //         "minesNext": {
  //             "id": 50,
  //             "active": 0,
  //             "payoutMultiplier": "1.09",
  //             "amountMultiplier": "1.09",
  //             "amount": "1.00",
  //             "payout": "0.00",
  //             "win": true
  //         },
  //         "state": {
  //             "mines": [
  //                 4
  //             ],
  //             "minesCount": 1,
  //             "grid": 5,
  //             "type": "manual",
  //             "rounds": [
  //                 25,
  //                 11
  //             ]
  //         }
  //     }
  // } 
  const response = await AuthHeader.axiosInstanceSelf().get('cashout');
  return response.data;
}

const minesAutoPlay = async (formData: any): Promise<any> => {
  // console.log(formData)
  // return {
  //       "success": true,
  //       "status": 200,
  //       "message": "Success",
  //       "data": {
  //           "minesNext": {
  //               "id": 50,
  //               "active": 0,
  //               "payoutMultiplier": "1.09",
  //               "amountMultiplier": "1.09",
  //               "amount": "1.00",
  //               "payout": "0.00",
  //               "win": true
  //           },
  //           "state": {
  //               "mines": [
  //                   4
  //               ],
  //               "minesCount": 1,
  //               "grid": 5,
  //               "type": "auto",
  //               "rounds": [
  //                   25,
  //                   11
  //               ]
  //           }
  //       }
  //   }         
  const response = await AuthHeader.axiosInstanceSelf().post('autoplay', formData);
  return response.data;
}

const paymentGateways = async (): Promise<any> => {
  const response = await AuthHeader.axiosInstanceSelf().get('payment-gateways');
  return response.data;
}

const gateway = async (formData: any): Promise<any> => {
  // return formData;  
  const response = await AuthHeader.axiosInstanceSelf().post('gateway', formData);
  return response.data;
}

const deposite = async (formData: any): Promise<any> => {
  // return formData;  
  const response = await AuthHeader.axiosInstanceSelf().post('deposite', formData);
  return response.data;
}

const checkIFSC = async (data: any): Promise<any> => {
  const response = await axios.get("https://ifsc.razorpay.com/" + data, {})
  return response.data;
}

const addBank = async (formData: any): Promise<any> => {
  // console.log(formData)  
  const response = await AuthHeader.axiosInstanceSelf().post("add-bank", formData);
  return response.data;
}

const bankList = async (): Promise<any> => {
  const response = await AuthHeader.axiosInstanceSelf().get('banks');
  return response.data;
}

const withdraw = async (formData: any): Promise<any> => {
  console.log(formData);
  const response = await AuthHeader.axiosInstanceSelf().post("withdrawal", formData);
  return response.data;
}

const loadAviator = async (): Promise<any> => {
  // return {
  //   "success": true,
  //   "status": 200,
  //   "message": "Game Loaded successfully",
  //   "data": {
  //     "started_at": null,
  //     "is_open": 1,
  //     "is_crashed": 0,
  //     "id": 1,
  //     "current_multiplier": 1.5,
  //     "round_history": [1,2,3,4,5],
  //     "history": [
  //       {
  //         "user_name": "Dr. Jasper O'Connell",
  //         "bet_amount": "100.00",
  //         "cashed_out_at": "1.94",
  //         "final_payout":"200",
  //         "id": 15
  //       },
  //       {
  //         "user_name": "Mr. Lester Kovacek",
  //         "bet_amount": "10.00",
  //         "cashed_out_at": "1.13",
  //         "final_payout":"200",
  //         "id": 14
  //       },
  //       {
  //         "user_name": "Rashad Johns",
  //         "bet_amount": "100.00",
  //         "cashed_out_at": "2.99",
  //         "final_payout":"200",
  //         "id": 13
  //       },
  //       {
  //         "user_name": "Ms. Celia Schmidt Jr.",
  //         "bet_amount": "100.00",
  //         "cashed_out_at": null,
  //         "final_payout":"200",
  //         "id": 12
  //       },
  //       {
  //         "user_name": "Prof. Keely Connelly DVM",
  //         "bet_amount": "100.00",
  //         "cashed_out_at": null,
  //         "final_payout":"200",
  //         "id": 11
  //       },
  //       {
  //         "user_name": "Mrs. Sally Kiehn Sr.",
  //         "bet_amount": "100.00",
  //         "cashed_out_at": null,
  //         "final_payout":"200",
  //         "id": 10
  //       },
  //       {
  //         "user_name": "Molly Crist",
  //         "bet_amount": "100.00",
  //         "cashed_out_at": null,
  //         "final_payout":"200",
  //         "id": 9
  //       },
  //       {
  //         "user_name": "Haleigh Howe",
  //         "bet_amount": "100.00",
  //         "cashed_out_at": null,
  //         "final_payout":"200",
  //         "id": 8
  //       }
  //     ]
  //   }
  // }
  const response = await AuthHeader.axiosInstanceSelf().get('load-aviator');
  return response.data;
}

const PlaceBetPlane = async (formData: any): Promise<any> => {
  // return {
  //   "success": true,
  //   "status": 200,
  //   "message": "Bet Generated successfully",
  //   "data": {
  //     "betId": 4,
  //     "status": true
  //   }
  // };
  const response = await AuthHeader.axiosInstanceSelf().post('aviator-bet', formData);
  return response.data;
}

const CancelBetPlane = async (formData: any): Promise<any> => {
  // return {
  //   "success": true,
  //   "status": 200,

  // } 
  const response = await AuthHeader.axiosInstanceSelf().post('cancel-aviator', formData);
  return response.data;
}

const CashoutPlane = async (formData: any): Promise<any> => {
  // return {
  //   "success": true,
  //   "status": 200,
  //   "message": "Bet Cashout successfully",
  //   "data": {
  //     "status": true
  //   }
  // };
  const response = await AuthHeader.axiosInstanceSelf().post('aviator-cashout', formData);
  return response.data;
}


const plinkoMultipliers = async (): Promise<any> => {
  // return formData;  
  const response = await AuthHeader.axiosInstanceSelf().get('plinko-multipliers');
  return response.data;
}

const PlaceBetPlinko = async (formData: any): Promise<any> => {
  //return formData;  
  //   return {
  //     "success": true,
  //     "status": 200,
  //     "message": "Bet Generated successfully",
  //     "data": {
  //         "path": [
  //             "R",
  //             "L",
  //             "R",
  //             "R",
  //             "R",
  //             "L",
  //             "L",
  //             "L"
  //         ],
  //         "dropPositions": [
  //             {
  //                 "row": 0,
  //                 "x": 1,
  //                 "direction": "R"
  //             },
  //             {
  //                 "row": 1,
  //                 "x": 0,
  //                 "direction": "L"
  //             },
  //             {
  //                 "row": 2,
  //                 "x": 1,
  //                 "direction": "R"
  //             },
  //             {
  //                 "row": 3,
  //                 "x": 2,
  //                 "direction": "R"
  //             },
  //             {
  //                 "row": 4,
  //                 "x": 3,
  //                 "direction": "R"
  //             },
  //             {
  //                 "row": 5,
  //                 "x": 2,
  //                 "direction": "L"
  //             },
  //             {
  //                 "row": 6,
  //                 "x": 1,
  //                 "direction": "L"
  //             },
  //             {
  //                 "row": 7,
  //                 "x": 0,
  //                 "direction": "L"
  //             }
  //         ],
  //         "finalBucket": 3,
  //         "multiplier": 1.1999999999999999555910790149937383830547332763671875,
  //         "payout": 0.1680000000000000104360964314764714799821376800537109375,
  //         "seeds": {
  //             "server": "863f81d9bfa7f79d7b403b40ecb2cca8a940a328abf4365f4bf7d066fbf3d936",
  //             "client": "f598de00500a609bbd255756be27eb71",
  //             "nonce": 0
  //         },
  //         "config": {
  //             "rows": "8",
  //             "risk": "low",
  //             "multipliers": [
  //                 2,
  //                 1.8000000000000000444089209850062616169452667236328125,
  //                 1.5,
  //                 1.1999999999999999555910790149937383830547332763671875,
  //                 1,
  //                 0.8000000000000000444089209850062616169452667236328125,
  //                 0.59999999999999997779553950749686919152736663818359375,
  //                 0.40000000000000002220446049250313080847263336181640625
  //             ]
  //         }
  //     }
  // }
  const response = await AuthHeader.axiosInstanceSelf().post('plinko-bet', formData);
  return response.data;
}

const plinkoCashout = async (formData: any): Promise<any> => {
  const response = await AuthHeader.axiosInstanceSelf().post('plinko-cashout', formData);
  return response.data;
}

const AuthService = {
  getGames,
  matchDetails,
  loadGames,
  getGameCasino,
  getMatchTitle,
  placeBetCricket,
  login,
  profile,
  wallet,
  logout,
  currency,
  statements,
  statementsDownload,
  statementsDetails,
  getActiveMinesGame,
  minesGame,
  checkCellData,
  chashOutMines,
  minesAutoPlay,
  paymentGateways,
  gateway,
  deposite,
  checkIFSC,
  addBank,
  bankList,
  withdraw,
  loadAviator,
  PlaceBetPlane,
  CancelBetPlane,
  CashoutPlane,
  PlaceBetPlinko,
  plinkoMultipliers,
  plinkoCashout,
  baseUrlImage
}

export default AuthService;
